module.exports = __webpack_public_path__ + "static/pic06.ed122634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic06.jpg
// module id = 489
// module chunks = 114276838955818